// extracted by mini-css-extract-plugin
export default {"title":"qcV5o","icon":"EoAj4"};